import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { setSelectedPaymentName } from 'Store/Order/actions';
import PickPayment from 'Components/PickPayment/PickPayment';

import { 
  getPaymentMethods, 
  getSelectedPaymentName,
  getOrderTotalPrice,
} from 'Store/Order/selectors';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

interface IPropsInternal {
  totalPrice: number;
  paymentMethods: Julius.Website.PaymentMethodViewModel[];
  selectedPaymentName: string;
  setSelectedPaymentName: (paymentName: string) => void;
}

type Props = IPropsInternal;

class PickPaymentContainer extends React.PureComponent<Props> {

  onPaymentItemChange = (paymentName: string, isChecked: boolean) => {
    const name = isChecked ? paymentName : null;
    this.props.setSelectedPaymentName(name);
  }

  render() {
    return (
      <WrapperBox>
        <PickPayment
          totalPrice={ this.props.totalPrice }
          paymentMethods={ this.props.paymentMethods }
          selectedPaymentName={ this.props.selectedPaymentName }
          onPaymentItemChange={ this.onPaymentItemChange }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    totalPrice: getOrderTotalPrice(state),
    paymentMethods: getPaymentMethods(state),
    selectedPaymentName: getSelectedPaymentName(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setSelectedPaymentName,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PickPaymentContainer);


// WEBPACK FOOTER //
// ./src/components/PickPayment/PickPaymentContainer.tsx